import { Text } from "components/common";
import React, { forwardRef, useContext } from "react";
import { css } from "@emotion/css";
import { CARD_HEIGHT } from "utils/constants";
import { UserContext } from "context";

const offset = 50;

type Props = {
  handleNext?: VoidFunction;
  handleShare: (option: 'twitter' | 'facebook' | 'linkedin') => void;
  index: number;
  ref: React.Ref<HTMLDivElement>;
  shareLoading?: boolean;
};
export const EmailThatNeededAttention = forwardRef<HTMLDivElement, Props>(({index}, ref) => {
  const {state: userState} = useContext(UserContext);
  const total = (userState?.emailStats?.totalUrgentEmails || 0);
  return (
    <div
    ref={ref}
      data-value={index}
      className={css`
        border: 1.825px solid #29282f;
        height: calc(100vh - ${offset}px);
        max-height: calc(${CARD_HEIGHT}px - ${offset}px);
        width: 100%;
        border-radius: 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding: 50px 24px 65px 24px;
        transition: transform 0.3s;
        background-color: #151419;

        &:hover {
          transform: translateY(1px);
        }
        position: relative;
        overflow: hidden;
      `}
    >
      <Gradient />
      <Text.Body
        style={{
          marginBottom: "140px",
          marginTop: "5px",
          fontSize: "28px",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        However, only <span style={{ color: "#AAEF65" }}>{total}</span> needed your
        attention that day based on our AI’s assessment.{" "}
      </Text.Body>
    </div>
  );
});

function Gradient() {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: row;
        position: relative;
      `}
    >
      {Array.from({ length: 5 }, (v, i) => i).map((item) => (
        <div
          key={item}
          style={{
            marginTop: -(155 - item * 15) + "px",
            marginLeft: -(item * 8) + "px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="122"
            height="337"
            viewBox="0 0 122 337"
            fill="none"
          >
            <path
              d="M121.145 276.742C121.145 309.968 94.2099 336.903 60.9837 336.903C27.7576 336.903 0.822428 309.968 0.822431 276.742L0.822453 -1.12981e-05L121.145 0L121.145 276.742Z"
              fill="url(#paint0_linear_6457_37)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_6457_37"
                x1="100.841"
                y1="303.843"
                x2="-42.4222"
                y2="120.797"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#6A53FE" stop-opacity="0.56" />
                <stop offset="1" stop-color="#6A53FE" stop-opacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      ))}
    </div>
  );
}
